(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-party-chairs"]) return;
  try {
    
  const partyChairs = document.querySelector('[data-party-chairs]');
  if (partyChairs && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealItems = partyChairs.querySelectorAll('.party-chairs__reveal');
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          currentObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    revealItems.forEach((item) => observer.observe(item));
  } else if (partyChairs) {
    partyChairs.querySelectorAll('.party-chairs__reveal').forEach((item) => item.classList.add('is-revealed'));
  }

  } catch(e) { console.error(e); }
})();
})();
